export const data = [
  {
    src: require("../assets/images/masonry/1.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/2.jpg"),
    width: 1,
    height: 1,
  },
  {
    src: require("../assets/images/masonry/3.jpg"),
    width: 3,
    height: 4,
  },
  {
    src: require("../assets/images/masonry/4.jpg"),
    width: 3,
    height: 4,
  },
  {
    src: require("../assets/images/masonry/5.jpg"),
    width: 3,
    height: 4,
  },
  {
    src: require("../assets/images/masonry/11.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/7.jpg"),
    width: 3,
    height: 4,
  },
  {
    src: require("../assets/images/masonry/8.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/9.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/10.jpg"),
    width: 3,
    height: 4,
  },
  {
    src: require("../assets/images/masonry/11.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/12.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/13.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/14.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/15.jpg"),
    width: 4,
    height: 3,
  },
  {
    src: require("../assets/images/masonry/1.jpg"),
    width: 4,
    height: 3,
  },
];

export const images = [
  require("../assets/images/big-lightgallry/013.jpg"),
  require("../assets/images/big-lightgallry/015.jpg"),
  require("../assets/images/big-lightgallry/014.jpg"),
  require("../assets/images/big-lightgallry/016.jpg"),
  require("../assets/images/big-lightgallry/01.jpg"),
  require("../assets/images/big-lightgallry/04.jpg"),
  require("../assets/images/big-lightgallry/05.jpg"),
  require("../assets/images/big-lightgallry/06.jpg"),
  require("../assets/images/big-lightgallry/012.jpg"),
  require("../assets/images/big-lightgallry/02.jpg"),
  require("../assets/images/big-lightgallry/07.jpg"),
  require("../assets/images/big-lightgallry/03.jpg"),
];

export const smallImages = [
  require("../assets/images/lightgallry/013.jpg"),
  require("../assets/images/lightgallry/015.jpg"),
  require("../assets/images/lightgallry/014.jpg"),
  require("../assets/images/lightgallry/016.jpg"),
  require("../assets/images/lightgallry/01.jpg"),
  require("../assets/images/lightgallry/04.jpg"),
  require("../assets/images/lightgallry/05.jpg"),
  require("../assets/images/lightgallry/06.jpg"),
  require("../assets/images/lightgallry/012.jpg"),
  require("../assets/images/lightgallry/02.jpg"),
  require("../assets/images/lightgallry/07.jpg"),
  require("../assets/images/lightgallry/03.jpg"),
];
